<template>
    <el-card>
        <el-form label-position="left">
            <el-form-item>
                <div >大类：</div>
                <el-select v-model="optionValue" default-first-option :placeholder='$t("reward_editor.2")' >
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <component-sub-reward :optionValue="optionValue" :confirmFinal="confirmFinal" :currentReward="currentReward" @conditionValue="getConditionValue" @value="getValue"></component-sub-reward>

        <component-reward-count :confirmFinal="confirmFinal" :currentReward="currentReward" @countValue="getCountValue"></component-reward-count>

        <el-form>
            <el-button @click="generateReward">确认添加奖励</el-button>
        </el-form>
    </el-card>

</template>

<script>
    import commonApi from '../service/common_api.js'
    import componentSubReward from '../components/component_sub_reward'
    import componentRewardCount from '../components/component_reward_count'
    import actionConfirm from '../mixins/action_confirm'
    export default {
        name: "component_main_reward",
        data() {
            return {
                optionValue: '0',
                options: [
                    {
                        value: '0',
                        label: this.$t("reward_editor.39")
                    },
                    {
                        value: '1',
                        label: this.$t("reward_editor.40")
                    },
                    {
                        value: '2',
                        label: this.$t("reward_editor.41")

                    },
                    {
                        value: '3',
                        label: this.$t("reward_editor.42")
                    },
                    {
                        value: '4',
                        label: this.$t("reward_editor.43")
                    },
                    {
                        value: '5',
                        label: '约束性道具'
                    },
                    {
                        value: '6',
                        label: this.$t("reward_editor.44")
                    },
                    {
                        value: '7',
                        label: '战纹'
                    },
                    {
                        value: '8',
                        label: this.$t("reward_editor.46")
                    },
                    {
                        value: '9',
                        label: this.$t("reward_editor.47")
                    },
                    {
                        value: '10',
                        label: '回复类道具'
                    },
                    {
                        value: '11',
                        label: '头像'
                    },
                    {
                        value: '12',
                        label: '头像框'
                    },
                    {
                        value: '13',
                        label: '宝箱'
                    },
                    {
                        value: '14',
                        label: '皮肤'
                    },
                    {
                        value: '15',
                        label: '时效类道具'
                    },
                    {
                        value: '17',
                        label: '起源盘'
                    },
                    {
                        value: '18',
                        label: '自选元核'
                    },
                    {
                        value: '19',
                        label: '进化光谱'
                    },
                    {
                        value: '20',
                        label: '聊天框'
                    },
                    {
                        value: '21',
                        label: '战斗框'
                    },
                    {
                        value: '22',
                        label: '元核碎片'
                    },
                    {
                        value: '23',
                        label: '元核髓'
                    }
                ],
                optionMap:{
                    '0':this.$t("reward_editor.39"),
                    '1':this.$t("reward_editor.40"),
                    '2':this.$t("reward_editor.41"),
                    '3':this.$t("reward_editor.42"),
                    '4':this.$t("reward_editor.43"),
                    '5':'约束性道具',
                    '6':this.$t("reward_editor.44"),
                    '7':'战纹',
                    '8':this.$t("reward_editor.46"),
                    '9':this.$t("reward_editor.47"),
                    '10':'回复类道具',
                    '11':'头像',
                    '12':'头像框',
                    '13':'宝箱',
                    '14':'皮肤',
                    '15':'时效类道具',
                    '17':'起源盘',
                    '18':'自选元核',
                    '19':'进化光谱',
                    '20':'聊天框',
                    '21':'战斗框',
                    '22':'元核碎片',
                    '23':'元核髓',
                },
                count1: '',
                count2: '',
                rateSwitch: false,
                isDetail: false,
                countSwitch: false,
                rate: 0.1,
                conditionValue: '',
                value: '',
                alertSwitch:0,
                confirmFinal: false,
                mainReward: {},

                finalCount: '',

                emblemEntryConfigs: [],
                emblemLevel: 1,
                emblemStage: 0,
                emblemQuality: 1,
                emblemFate:0,
                emblemFateCustomizeTags:[],
                emblemFateCustomize:100,
                emblemMainProperty: 1,
                emblemFateProperty: 51,
                editEmblemFateQuality: 0,
                editEmblemFateRdFloat: 0,
                editEmblemEntries:[
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ],
                emblemMainConfigs: [],
                emblemFateConfigs: [],
            }
        },
        mixins: [actionConfirm],
        props: ['currentReward', 'currentRewardIdx'],
        watch: {
            currentReward(n, l) {
                if (n!==l) {
                    this.resolveRewardStr(this.currentReward);

                }
            },
        },
        mounted() {
          this.initData()
        },
        methods: {
            getCountValue(finalCount, rateSwitch, rate) {
                this.rateSwitch = rateSwitch;
                this.rate = rate;
                this.finalCount = finalCount;
            },

            getConditionValue(conditionValue) {
                this.conditionValue = conditionValue;
            },

            getValue(value) {
                this.value = value;
            },

            generateReward() {
                var self = this;
                self.confirmFinal = true;
                setTimeout(()=> {
                    self.confirmFinal = false;
                    if (self.value == '') {
                        this.$message({
                            type: 'info',
                            message: '请选择编号'
                        })
                        return;
                    }

                    let finalContent = self.optionValue + "$" + self.value + "_" + self.finalCount;

                    if (self.conditionValue != '') {
                        finalContent = finalContent + "_" + self.conditionValue;
                    }

                    //概率串
                    if (self.rateSwitch) {
                        finalContent = finalContent + "|" + self.rate;
                    }

                    self.mainReward = finalContent;

                    let optionValueCN = self.optionMap[self.optionValue];

                    let idCn = self.getIdCn(self.optionValue,self.value);
                    let finalContentCN = optionValueCN + "$" + idCn + "_" + self.finalCount;

                    this.$emit('reward', self.mainReward, this.currentRewardIdx, finalContentCN)
                },1000)
            },

            getIdCn(optionValue,id){
                let self = this;
                if(optionValue == "0" || optionValue == "3" || optionValue == "4" || optionValue == "5" || optionValue == "9" ||
                    optionValue == "10" || optionValue == "11" || optionValue == "12" || optionValue == "13" || optionValue == "14" || optionValue == "15" ||
                    optionValue == "20" || optionValue == "21" || optionValue == "22"){
                    //道具
                    return self.$t('propConfigName_'+id);
                }else if(optionValue == "1"){
                    //怪兽
                    return self.$t('monsterName_' + id);
                }else if(optionValue == "2"){
                    //怪兽碎片
                    return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
                }else if(optionValue == "6"){
                    //怪兽觉醒水晶
                    return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
                }else if(optionValue == "8"){
                    //怪兽觉醒水晶碎片
                    return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
                }else if(optionValue == "7"){
                    //战纹
                    return self.$t('warGrooveConfigName_' + id);
                }else if(optionValue == "19"){
                    //怪兽觉醒水晶碎片
                    return self.$t('monsterName_' + ((id>>0)-70000)) + "的进化光谱";
                }
            },

            resolveRewardStr(str){
                let self = this;

                if (str == '') {
                    self.countSwitch = false;
                    self.rateSwitch = false;
                    self.isDetail = false;
                    self.count1 = 1;
                    self.count2 = 1;
                    self.rate = 0.1;
                    self.emblemLevel = 1;
                    self.emblemStage = 0;
                    self.emblemQuality = 1;
                    self.emblemMainProperty = 1;
                    self.emblemFate = 0;
                    self.emblemFateCustomize = 100;
                    self.emblemFateProperty = 51;
                    self.editEmblemFateQuality = 0;
                    self.editEmblemFateRdFloat = 0;

                    self.editEmblemEntries = [
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:true
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:false
                        },
                    ]
                }

                let rewardArray = str.toString().split("_");

                for (let index = 0; index < rewardArray.length; index++) {
                    const element = rewardArray[index];
                    switch (index) {
                        case 0:
                            let bigTypeArry = element.split("$");
                            //大类
                            self.optionValue = bigTypeArry[0];
                            //identify
                            self.value = parseInt(bigTypeArry[1]);
                            if (self.value == 50001) {
                                self.emblemRandomByQuality = false;
                            } else {
                                self.emblemRandomByQuality = true;
                            }
                            break;
                        case 1:
                            //数量
                            let countArry = element.split("-");
                            if(countArry.length>1){
                                self.countSwitch = true;
                                self.count1 = countArry[0];
                                let rateAndCount = countArry[1].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count2 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count2 = countArry[1];
                                }
                            }else{
                                self.countSwitch = false;

                                let rateAndCount = countArry[0].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count1 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count1 = countArry[0];
                                }
                            }
                            break;
                        case 2:
                            //等级
                            self.emblemLevel = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveQuality = parseInt(element);
                            }
                            break;
                        case 3:
                            //阶段
                            self.emblemStage = parseInt(element);

                            if (self.optionValue == '7') {
                                if (element) {
                                    self.warGrooveChannelSwitch = true;
                                    self.warGrooveChannelUp = parseInt(element);
                                } else {
                                    self.warGrooveChannelSwitch = false;
                                }
                            }
                            break;
                        case 4:
                            //品质
                            self.emblemQuality = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelDown = parseInt(element);
                            }
                            break;
                        case 5:
                            //宿命
                            let fateArray = element.split("#");
                            if(fateArray.length>=1 && fateArray[0].split("@").length>1){
                                self.emblemFate = 3;
                                for (let i = 0; i < fateArray.length; i++) {
                                    let item = fateArray[i].split("@");
                                    for(let j=0;j<self.emblemFateConfigs.length;j++){
                                        if(self.emblemFateConfigs[j].id==parseInt(item[0])){
                                            self.emblemFateCustomizeTags[i] = {id:item[0],chance:item[1],quality:item[2],rdFloat:parseFloat(item[3]),data:self.emblemFateConfigs[j]}
                                        }
                                    }
                                }
                            }else{
                                if(element>0){
                                    self.emblemFate = 2;
                                    self.emblemFateProperty = parseInt(element);
                                }else{
                                    self.emblemFate = 0;
                                }
                            }

                            if (self.optionValue == '7') {
                                self.warGrooveChannelLeft = parseInt(element);
                            }

                            break;
                        case 6:
                            //宿命自定义概率
                            self.emblemFateCustomize = parseInt(element*100);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelRight = parseInt(element);
                            }
                            break;
                        case 7:
                            //主属性
                            self.emblemMainProperty = parseInt(element);
                            break;
                        case 8:
                            //词条属性
                            let entryArray = element.split("#");
                            for (let index = 0; index < entryArray.length; index++) {
                                const entryItem = entryArray[index];
                                let current = self.editEmblemEntries[index];

                                self.emblemEntryConfigs.forEach(item => {
                                    item.children.forEach(iitem => {
                                        if (iitem.value == entryItem.split('@')[0]&&entryItem.split('@').length>1) {
                                            current.entry = [item.value,iitem.value];
                                        }
                                    })
                                })

                                current.quality = parseInt(entryItem.split('@')[1]);
                                current.rdFloat = entryItem.split('@')[2];
                            }

                            let countAndEntry = entryArray[entryArray.length-1].split('|');
                            if (countAndEntry.length>1) {
                                self.rateSwitch = true;
                                self.rate = countAndEntry[1];
                            } else {
                                self.rateSwitch = false;
                            }
                            //强制刷新一次变量
                            // self.onEmblemQualityChange();
                            let quality = self.emblemQuality;

                            for(let i=0;i<self.editEmblemEntries.length;i++){
                                if(i<quality){
                                    self.editEmblemEntries[i].active = true;
                                }else{
                                    self.editEmblemEntries[i].active = false;
                                }
                            }
                            break;
                        default:
                            break;
                    }
                }
            },

            initData: function() {
                let self = this;
                let tables = 'monster_config,war_groove_config,skin_config,god_config,emblem_effect_config,prop_config';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.monsterConfigs = [];
                    self.propConfig = res.prop_config;
                    self.emblemEffectConfig = res.emblem_effect_config;
                    self.godConfigs = res.god_config;
                    self.wallGainType = res.war_groove_config;
                    self.skinGainType = res.skin_config;

                    res.monster_config.forEach(configItem=>{
                        if (configItem.special === 0){
                            self.monsterConfigs.push(configItem);
                        }
                    })


                    let arrProp0 = [];
                    let arrProp3 = [];
                    let arrProp4 = [];
                    let arrConditionProp = [];
                    let arrProp9 = [];
                    let arrProp10 = [];
                    let arrProp11 = [];
                    let arrProp12 = [];
                    let arrProp13 = [];
                    let arrProp14 = [];
                    let arrProp15 = [];
                    let arrProp23 = [];
                    res.prop_config.forEach(function(item) {
                        let type = item.big_type;
                        if (type == 0) {
                            arrProp0.push(item);
                        } else if (type == 3) {
                            arrProp3.push(item);
                        }  else if (type == 5) {
                            arrConditionProp.push(item);
                        }else if (type == 9) {
                            arrProp9.push(item);
                        }else if(type == 4){
                            arrProp4.push(item);
                        } else if (type == 10) {
                            arrProp10.push(item)
                        } else if (type == 11) {
                            arrProp11.push(item)
                        } else if (type == 12) {
                            arrProp12.push(item)
                        } else if (type == 13) {
                            arrProp13.push(item)
                        } else if (type == 14) {
                            arrProp14.push(item)
                        } else if (type == 15) {
                            arrProp15.push(item)
                        } else if (type == 23) {
                            arrProp23.push(item)
                        }
                    });
                    self.arrProp0 = arrProp0;
                    self.arrProp3 = arrProp3;
                    self.arrProp4 = arrProp4;
                    self.arrConditionProp = arrConditionProp;
                    //元核属性类型: 0-主属性;1-二字词条;2-四字词条;3-宿命
                    let tw = {
                        value: 1,
                        label: this.$t("reward_editor.37"),
                        children: []
                    };
                    let fw = {
                        value: 2,
                        label: this.$t("reward_editor.38"),
                        children: []
                    };
                    let special = {
                        value: 3,
                        label: this.$t("reward_editor.52"),
                        children: [{
                            value: 0,
                            label: this.$t("reward_editor.48"),
                        }]
                    }

                    let twConfigs = [];
                    let fwConfigs = [];
                    res.emblem_effect_config.forEach(function(item) {
                        if (item.type == 0) {
                            self.emblemMainConfigs.push(item);
                        } else if (item.type == 1) {
                            twConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type == 2) {
                            fwConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type == 3) {
                            self.emblemFateConfigs.push(item);
                        }
                    });
                    tw.children = twConfigs;
                    fw.children = fwConfigs;
                    self.emblemEntryConfigs.push(tw);
                    self.emblemEntryConfigs.push(fw);
                    self.emblemEntryConfigs.push(special);
                    self.arrProp9 = arrProp9;
                    self.arrProp10 = arrProp10;
                    self.arrProp11 = arrProp11;
                    self.arrProp12 = arrProp12;
                    self.arrProp13 = arrProp13;
                    self.arrProp14 = arrProp14;
                    self.arrProp15 = arrProp15;

                    let arrProp6 = [];
                    self.monsterConfigs.forEach(function(item) {
                        let monsterRace = item.race;
                        let monsterQuality = item.quality;
                        if (monsterQuality === 4 && monsterRace.indexOf("_") > -1) {
                            arrProp6.push(item);
                        }
                    });
                    self.arrProp6 = arrProp6;

                    let arrProp7 = [];
                    res.war_groove_config.forEach(function(item) {
                        let type = item.type;
                        if (type === 3 || type === 4) {
                            arrProp7.push(item);
                        }
                    });
                    self.arrProp7 = arrProp7;

                    self.arrProp23 = arrProp23;


                    //self.glyphFateType = arr2;
                })
            },
        },
        components: {
            componentSubReward,
            componentRewardCount
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/component_main_reward.vue